module.exports = __webpack_public_path__ + "img/icon-calendar.3560587c.svg";